export default __webpack_public_path__ + "../staticImages/sprite-paypalcheckout-2x.png";